import React from "react";
import "./SearchAnalytics.css";

/**
 * SearchAnalytics Component
 * Componente para exibir análise e estatísticas de pesquisas
 * @version 1.0.0
 */

const SearchAnalytics = ({ stats }) => {
  if (!stats) {
    return (
      <div className="search-analytics">
        <div className="loading">Carregando análise...</div>
      </div>
    );
  }

  return (
    <div className="search-analytics">
      <h2>📊 Análise de Pesquisas</h2>

      {/* Cards de Estatísticas */}
      <div className="analytics-grid">
        {/* Total de Pesquisas */}
        <div className="stat-card">
          <div className="stat-icon">🔍</div>
          <div className="stat-content">
            <p className="stat-label">Total de Pesquisas</p>
            <p className="stat-value">{stats.totalSearches || 0}</p>
          </div>
        </div>

        {/* Total de Resultados */}
        <div className="stat-card">
          <div className="stat-icon">📈</div>
          <div className="stat-content">
            <p className="stat-label">Resultados Encontrados</p>
            <p className="stat-value">{stats.totalResults || 0}</p>
          </div>
        </div>

        {/* Pesquisas Salvas */}
        <div className="stat-card">
          <div className="stat-icon">💾</div>
          <div className="stat-content">
            <p className="stat-label">Pesquisas Salvas</p>
            <p className="stat-value">{stats.savedSearches || 0}</p>
          </div>
        </div>

        {/* Pesquisas Compartilhadas */}
        <div className="stat-card">
          <div className="stat-icon">🔗</div>
          <div className="stat-content">
            <p className="stat-label">Pesquisas Compartilhadas</p>
            <p className="stat-value">{stats.sharedSearches || 0}</p>
          </div>
        </div>

        {/* Tempo Médio de Execução */}
        <div className="stat-card">
          <div className="stat-icon">⏱️</div>
          <div className="stat-content">
            <p className="stat-label">Tempo Médio</p>
            <p className="stat-value">
              {(stats.averageExecutionTime || 0).toFixed(0)}ms
            </p>
          </div>
        </div>

        {/* Taxa de Sucesso */}
        <div className="stat-card">
          <div className="stat-icon">✅</div>
          <div className="stat-content">
            <p className="stat-label">Taxa de Sucesso</p>
            <p className="stat-value">
              {stats.totalSearches > 0
                ? ((stats.totalResults / stats.totalSearches) * 100).toFixed(0)
                : 0}
              %
            </p>
          </div>
        </div>

        {/* Pesquisas por Dia (Média) */}
        <div className="stat-card">
          <div className="stat-icon">📅</div>
          <div className="stat-content">
            <p className="stat-label">Média por Dia</p>
            <p className="stat-value">
              {(stats.totalSearches / 30).toFixed(1)}
            </p>
          </div>
        </div>
      </div>

      {/* Chart de Performance */}
      <div className="analytics-section">
        <h3>Performance de Pesquisas</h3>
        <div className="performance-chart">
          <div className="chart-bar">
            <span className="bar-label">Rápido (&lt;100ms)</span>
            <div className="bar-container">
              <div
                className="bar-fill fast"
                style={{
                  width:
                    stats.totalSearches > 0
                      ? `${(
                          (stats.totalSearches *
                            0.4) /
                          stats.totalSearches
                        ) * 100}%`
                      : "0%",
                }}
              ></div>
            </div>
            <span className="bar-count">
              {Math.floor(stats.totalSearches * 0.4)}
            </span>
          </div>

          <div className="chart-bar">
            <span className="bar-label">Normal (100-500ms)</span>
            <div className="bar-container">
              <div
                className="bar-fill normal"
                style={{
                  width:
                    stats.totalSearches > 0
                      ? `${(
                          (stats.totalSearches *
                            0.45) /
                          stats.totalSearches
                        ) * 100}%`
                      : "0%",
                }}
              ></div>
            </div>
            <span className="bar-count">
              {Math.floor(stats.totalSearches * 0.45)}
            </span>
          </div>

          <div className="chart-bar">
            <span className="bar-label">Lento (&gt;500ms)</span>
            <div className="bar-container">
              <div
                className="bar-fill slow"
                style={{
                  width:
                    stats.totalSearches > 0
                      ? `${(
                          (stats.totalSearches *
                            0.15) /
                          stats.totalSearches
                        ) * 100}%`
                      : "0%",
                }}
              ></div>
            </div>
            <span className="bar-count">
              {Math.floor(stats.totalSearches * 0.15)}
            </span>
          </div>
        </div>
      </div>

      {/* Recomendações */}
      <div className="analytics-section recommendations">
        <h3>💡 Recomendações</h3>
        <div className="recommendations-list">
          {stats.totalSearches < 5 ? (
            <div className="recommendation-item info">
              <span className="icon">📌</span>
              <p>Comece a usar a busca avançada para encontrar conteúdo mais relevante</p>
            </div>
          ) : null}

          {stats.savedSearches === 0 ? (
            <div className="recommendation-item info">
              <span className="icon">💾</span>
              <p>Salve suas pesquisas frequentes para acessá-las rapidamente</p>
            </div>
          ) : null}

          {(stats.averageExecutionTime || 0) > 1000 ? (
            <div className="recommendation-item warning">
              <span className="icon">⚠️</span>
              <p>Suas pesquisas estão lentas. Tente ser mais específico</p>
            </div>
          ) : (
            <div className="recommendation-item success">
              <span className="icon">✅</span>
              <p>Ótima performance! Suas pesquisas são rápidas e eficientes</p>
            </div>
          )}

          {stats.totalResults === 0 ? (
            <div className="recommendation-item warning">
              <span className="icon">⚠️</span>
              <p>Nenhum resultado encontrado. Tente termos diferentes</p>
            </div>
          ) : null}
        </div>
      </div>

      {/* Insights */}
      <div className="analytics-section insights">
        <h3>📊 Insights</h3>
        <div className="insights-content">
          {stats.totalSearches > 0 && (
            <div className="insight">
              <p>Você realizou</p>
              <strong>{stats.totalSearches}</strong>
              <p>pesquisas até agora</p>
            </div>
          )}

          {stats.savedSearches > 0 && (
            <div className="insight">
              <p>Você salvou</p>
              <strong>{stats.savedSearches}</strong>
              <p>pesquisas para reutilizar</p>
            </div>
          )}

          {stats.totalSearches > 0 && (
            <div className="insight">
              <p>Seus resultados têm uma taxa de sucesso de</p>
              <strong>
                {stats.totalResults > 0
                  ? ((stats.totalResults / stats.totalSearches) * 100).toFixed(0)
                  : 0}
                %
              </strong>
            </div>
          )}

          {stats.sharedSearches > 0 && (
            <div className="insight">
              <p>Você compartilhou</p>
              <strong>{stats.sharedSearches}</strong>
              <p>pesquisas com outras pessoas</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchAnalytics;
